import { render, staticRenderFns } from "./areas-staffs.vue?vue&type=template&id=3239922c&"
import script from "./areas-staffs.vue?vue&type=script&lang=js&"
export * from "./areas-staffs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports